import React, { useState } from 'react';

const CommunityReport = ({
  isOpen,
  closeReport,
  category,
  relTable,
  mbId,
  wrId,
  items = [],
  title = '신고하기'
}) => {
  const [reportType, setReportType] = useState('비매너');
  const [reportContent, setReportContent] = useState('');

  if (!isOpen) {
    return null;
  }

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!reportType) {
      alert('신고 유형을 선택하세요');
      return;
    }

    let finalContent = reportType;
    if (reportType === '기타 부정행위') {
      if (!reportContent || reportContent.trim().length < 5) {
        alert('신고내용을 5글자 이상 작성해주세요.');
        return;
      }
      finalContent = reportContent.trim();
    }

    let params = {
      category: category,
      type: reportType,
      content: finalContent,
      relId: wrId,
      relTable: relTable,
      targetId: mbId
    };

    await items.actionReport(params);
    closeReport();
    setReportType('비매너');
    setReportContent('');
  };

  const handleRadio = (e) => {
    setReportType(e.target.value);
  };

  const handleContent = (e) => {
    setReportContent(e.target.value);
  };

  return (
    <div className="ly_report">
      <div className="inner">
        <h5 className="tit">{title}</h5>
        <ul className="list">
          <li>
            <input
              type="radio"
              id="chk_report1"
              name="chk_report"
              className="radio blind"
              value={'비매너'}
              checked={reportType === '비매너'}
              onChange={handleRadio}
              autoComplete="off"
            />
            <label htmlFor="chk_report1" className="radio_label">
              비매너
            </label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_report2"
              name="chk_report"
              className="radio blind"
              value={'회원 낚시'}
              checked={reportType === '회원 낚시'}
              onChange={handleRadio}
              autoComplete="off"
            />
            <label htmlFor="chk_report2" className="radio_label">
              회원 낚시
            </label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_report3"
              name="chk_report"
              className="radio blind"
              value={'운영자, 싸이트 비방'}
              checked={reportType === '운영자, 싸이트 비방'}
              onChange={handleRadio}
              autoComplete="off"
            />
            <label htmlFor="chk_report3" className="radio_label">
              운영자, 싸이트 비방
            </label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_report4"
              name="chk_report"
              className="radio blind"
              value={'개인정보 노출'}
              checked={reportType === '개인정보 노출'}
              onChange={handleRadio}
              autoComplete="off"
            />
            <label htmlFor="chk_report4" className="radio_label">
              개인정보 노출
            </label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_report5"
              name="chk_report"
              className="radio blind"
              value={'개인, 불법적인 홍보행위'}
              checked={reportType === '개인, 불법적인 홍보행위'}
              onChange={handleRadio}
              autoComplete="off"
            />
            <label htmlFor="chk_report5" className="radio_label">
              개인, 불법적인 홍보행위
            </label>
          </li>
          <li>
            <input
              type="radio"
              id="chk_report6"
              name="chk_report"
              className="radio blind"
              value={'기타 부정행위'}
              checked={reportType === '기타 부정행위'}
              onChange={handleRadio}
              autoComplete="off"
            />
            <label htmlFor="chk_report6" className="radio_label">
              기타 부정행위
            </label>
          </li>
        </ul>
        {reportType === '기타 부정행위' && (
          <div className="report_cont">
            <textarea
              placeholder="신고내용을 작성해주세요."
              value={reportContent}
              onChange={handleContent}
            ></textarea>
          </div>
        )}
        <div className="btn_area">
          <button type="button" className="btn_cancel" onClick={closeReport}>
            취소
          </button>
          <button type="button" className="btn_submit" onClick={onSubmit}>
            신고
          </button>
        </div>
        <button type="button" className="btn_close" onClick={closeReport}>
          닫기
        </button>
      </div>
    </div>
  );
};

export default CommunityReport;
